export default __webpack_public_path__ + "static/media/33.3275a5d8.mp3";